import { render, staticRenderFns } from "./CompanyManagementForm.vue?vue&type=template&id=154004f7"
import script from "./CompanyManagementForm.vue?vue&type=script&lang=js"
export * from "./CompanyManagementForm.vue?vue&type=script&lang=js"
import style0 from "./CompanyManagementForm.vue?vue&type=style&index=0&id=154004f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports